import { merge, mergeWith } from 'lodash';

import { MERGE_ENTITIES, UPDATE_ENTITIES, CLEAR_ENTITIES } from './types';

const initState = {
  webChat: {},
};

const mergeWithArray = (objValue, srcValue) => {
  if (objValue && srcValue && Array.isArray(objValue)) {
    return [...srcValue];
  }
};
export default function reducer(state = initState, action) {
  const { type, payload, module } = action;
  switch (type) {
    case MERGE_ENTITIES:
      return {
        ...state,
        [module]: mergeWith({}, state[module], payload.entities, mergeWithArray),
      };
    case UPDATE_ENTITIES: {
      const { entity, data, id } = payload;
      if (!state[module][entity]) {
        return state;
      }
      const oldEntity = state[module][entity][id];
      return merge({}, state, {
        [module]: {
          [entity]: {
            [id]: {
              ...oldEntity,
              ...data,
            },
          },
        },
      });
    }

    case CLEAR_ENTITIES: {
      const { entity } = payload;
      return {
        ...state,
        [module]: {
          ...state[module],
          [entity]: {},
        },
      };
    }
    default:
      return state;
  }
}
